/**
 * Хук, который сохраняет и восстанавливает значение scrollY страницы,
 * когда пользователь переходит на другую страницу, чей путь начинается
 * с nextPageUrlStartsWith.
 */
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export function usePreserveScrollY(nextPageUrlStartsWith: string) {
    const router = useRouter();
    const PRESERVED_SCROLL_Y_STORAGE_NAME = `PRESERVED_SCROLL_Y_${nextPageUrlStartsWith}`;

    useEffect(() => {
        const preservedScrollY = sessionStorage.getItem(PRESERVED_SCROLL_Y_STORAGE_NAME);

        if (preservedScrollY) {
            window.scroll({ top: parseFloat(preservedScrollY), behavior: 'auto' });
        }

        sessionStorage.removeItem(PRESERVED_SCROLL_Y_STORAGE_NAME);
    }, [PRESERVED_SCROLL_Y_STORAGE_NAME]);

    useEffect(() => {
        const onRouteChange = (nextPagePathname: string) => {
            const pathname = nextPagePathname.replace(/\/filter\/.*/, '');

            if (pathname.startsWith(nextPageUrlStartsWith) && pathname !== nextPageUrlStartsWith) {
                sessionStorage.setItem(PRESERVED_SCROLL_Y_STORAGE_NAME, window.scrollY.toString());
            } else {
                sessionStorage.removeItem(PRESERVED_SCROLL_Y_STORAGE_NAME);
            }
        };

        router.events.on('routeChangeStart', onRouteChange);

        return () => {
            router.events.off('routeChangeStart', onRouteChange);
        };
    }, [router, nextPageUrlStartsWith, PRESERVED_SCROLL_Y_STORAGE_NAME]);
}
